export default "__VITE_ASSET__ZkfdIr4Q__"